import clsx from 'clsx'
import { useState } from 'preact/hooks'
import { render } from 'preact'
import Icon from '@/components/snippets/icon/icon'
import { globalState } from '@/components/helpers/utils'
import { QuickAddSizeSelector } from 'libs/searchspring/components/QuickAddSizeSelector'

const MODAL_ID = 'modal-quick-add'

const isInStock = (variant, stockLevels) => {
  if (!variant) return false
  const quantity = variant.inventory_quantity
  const zeroStockLevel = stockLevels.find(stock => stock.max_quantity === 0)
  if (quantity <= 0 && !zeroStockLevel) return false
  return quantity > 0
}

const closeModal = () => {
  const modal = document.querySelector(`x-modal[data-id="${MODAL_ID}"]`)
  if (modal && typeof modal.handleHide === 'function') {
    modal.handleHide()
  }
}

const openModal = () => {
  setTimeout(() => {
    const modal = document.querySelector(`x-modal[data-id="${MODAL_ID}"]`)
    if (modal && typeof modal.handleToggle === 'function') {
      modal.handleToggle()
    }
  }, 100)
}

function QuickAddModalContent({ result, onClose }) {
  return (
    <>
      <div className="shrink-0 flex items-center justify-between sticky top-0 pl-margin py-0.125 bg-secondary border-b border-borders-default z-20">
        <h2 className="paragraph-xs font-base-spaced uppercase">Select Size To Add To Bag</h2>
        <button
          className="btn btn-transparent btn-square btn-m"
          data-modal-parent={MODAL_ID}
          data-modal-role="close"
          aria-label="Close quick add modal"
          onClick={onClose}
          type="button"
        >
          <div class="size-[9px] children:size-full">
            <Icon id="close" />
          </div>
        </button>
      </div>
      <div className="grow flex flex-col overflow-y-scroll no-scrollbar overscroll-y-none py-0.5">
        <QuickAddSizeSelector
          result={result}
          onAddSuccess={onClose}
          buttonClass="min-w-[62.5px]"
        />
      </div>
    </>
  )
}

export function ResultQuickAdd({ result }) {
  const variants = Array.isArray(result.variants) ? result.variants : []
  if (variants.length === 0) return null

  const stockLevels = globalState?.metaobjects.stock_indicators?.sort((a, b) => b.max_quantity - a.max_quantity) || []
  const hasSingleVariant = variants.length === 1
  const singleVariant = hasSingleVariant ? variants[0] : null
  const [loading, setLoading] = useState(false)

  const handleAddToCart = async (variant) => {
    if (loading || !variant?.id || !window.Cart) return
    const variantId = typeof variant.id === 'string' ? parseInt(variant.id, 10) : variant.id
    setLoading(true)
    try {
      await window.Cart.addLineItems({ id: variantId, quantity: 1 })
    } catch (error) {
      console.error('Error adding item to cart:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleModalOpen = () => {
    const quickAddContainer = document.querySelector('[data-quick-add-inner]')
    if (quickAddContainer) {
      const productKey = result.uid || result.id || result.handle
      render(
        <QuickAddModalContent
          key={productKey}
          result={result}
          onClose={closeModal}
        />,
        quickAddContainer
      )
    }
    openModal()
  }

  if (hasSingleVariant) {
    const inStock = isInStock(singleVariant, stockLevels)

    return (
      <button
        type="button"
        className={clsx(
          'btn btn-text btn-primary btn-m w-fit',
          (!inStock || loading) && 'disabled'
        )}
        onClick={() => handleAddToCart(singleVariant)}
        disabled={!inStock || loading}
        aria-label="Add to bag"
        aria-busy={loading}
      >
        <span className="text-line text-line-large">Add to Bag</span>
      </button>
    )
  }

  return (
    <button
      type="button"
      className="btn btn-text btn-primary btn-m w-fit"
      onClick={handleModalOpen}
      aria-label="Select a size to add to bag"
    >
      <span className="text-line text-line-large">Select Size</span>
    </button>
  )
}
